
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import ProfileAbout from '@/components/Profile/ProfileAbout.vue';
  import ProfileAchievements from '@/components/Profile/ProfileAchievements.vue';
  import ProfileActivities from '@/components/Profile/activity/ProfileActivities.vue';
  import ProfileTeams from '@/components/Profile/ProfileTeams.vue';
  import ProfileFollowing from '@/components/Profile/ProfileFollowing.vue';
  import {authModule, userState} from '@/utils/store-acessor';
  import Footer from '@/components/Footer.vue';

  @Component({
    components: {
      ProfileFollowing,
      ProfileTeams,
      ProfileActivities,
      ProfileAchievements,
      ProfileAbout,
      Footer
    }
  })
  export default class ProfilePage extends Vue {
    tab: any | null = null;
    @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;

    async mounted() {
      if (this.isAuthenticated) {
        await userState.fetchUser();
      }
    }
  }
